import { Alert, message, Typography } from 'antd';
import { FC, useEffect } from 'react';

import { ConfirmModal } from '@/components/ConfirmModal';
import BybitForm from '@/components/SearchTablePage/BybitForm';
import { FormType } from '@/components/SearchTablePage/types/tplTypes';
import { useI18nContext } from '@/i18n/I18n';
import { useFormItem } from '@/pages/apiManagement/createApiPage/comps/ApiInfoModal/helper';

const { Paragraph } = Typography;

interface IApiKeyInfo {
  apiKey: string;
  note: string;
  permissions?: string;
  secret: string;
}
interface IApiInfoModal {
  showDetailModal: boolean;
  apiKeyInfo: IApiKeyInfo;
  closeModal: () => void;
}

export const SecretModal: FC<IApiInfoModal> = (props) => {
  const { showDetailModal, apiKeyInfo, closeModal } = props;
  const [$t] = useI18nContext();

  const { getFormItems } = useFormItem();
  useEffect(() => {
    console.log('apiKeyInfo==', apiKeyInfo);
  }, []);

  const renderSuffix = (key: 'apiKey' | 'secret') => {
    return (
      <Paragraph
        copyable={{
          text: apiKeyInfo[key] || ' ',
          icon: [
            <span key="beforeCopy">{$t('apiAdd.copy')}</span>,
            <span key="copySuccess">{$t('apiAdd.copy')}</span>,
          ],
          tooltips: ['', ''],
          onCopy: () => {
            message.success($t('apiAdd.copySuccess'));
          },
        }}
        style={{ margin: 0 }}
      ></Paragraph>
    );
  };

  const _handleFormItem = (item: any) => {
    // 换label展示
    if (item.id === 'apiKey') {
      item.label = $t('oauthAdmin.clientID');
    } else if (item.id === 'secret') {
      item.label = $t('oauthAdmin.clientSecret');
    }
    return item;
  };

  const getFormProps = () => {
    return {
      configData: {
        query: getFormItems(renderSuffix).slice(0, 3).map(_handleFormItem),
      },
      formType: FormType.Form,

      initialValues: apiKeyInfo,
      handleSearch: () => console.log('success'),
    };
  };

  const renderContent = () => {
    return (
      <div>
        <Alert
          message={$t('apiCreatedTip')}
          type="warning"
          showIcon
          style={{ marginBottom: 24 }}
        />
        <BybitForm<IApiKeyInfo>
          formProps={{
            layout: 'vertical',
          }}
          {...getFormProps()}
        />
      </div>
    );
  };
  return (
    <ConfirmModal
      isVisible={showDetailModal}
      title={$t('Key added successfully')}
      content={renderContent()}
      onCancel={() => closeModal()}
      okBtnText={$t('iKnow')}
      onConfirm={() => closeModal()}
    />
  );
};
